import { render } from "./organization.vue?vue&type=template&id=05b7d36a"
import script from "./organization.vue?vue&type=script&lang=js"
export * from "./organization.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/shared/users/organization.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05b7d36a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05b7d36a', __exports__)) {
    console.log('reload')
    api.reload('05b7d36a', __exports__)
  }
  
  module.hot.accept("./organization.vue?vue&type=template&id=05b7d36a", () => {
    console.log('re-render')
    api.rerender('05b7d36a', render)
  })

}


export default __exports__